import {
  B2bIndividualOperationInitiatorValues,
  B2bIndividualOperationTypeValues,
  GetB2bIndividualOperationOneResponse,
  GetB2bIndividualOperationOrderResponse,
} from '@Common/types/bo/b2b/individual_operations';

export const b2bIndividualOperationsTranslations = {
  list: {
    empty: 'Aucune opération individuelle trouvée',
  },
  tabs: {
    all: {
      label: 'Toutes',
    },
  },
  show: {
    title: 'Détails',
    orders_title: 'Détail par ordre éligible',
    orders_empty: 'Les ordres associés ne sont pas encore disponibles',
  },
  fields: {
    id: 'ID',
    side: 'Sens',
    equipment: 'Équipement',
    type: 'Type',
    execution_date: "Date d'exécution",
    reference_period: 'Période de référence',
    status: 'Statut',
    cancellation_reason: "Raison d'annulation",
    cancellation_initiator: "Initiateur de l'annulation",
    social_status: 'Statut social',
    total_gross_amount: 'Montant brut total',
    total_entry_fee_employee_amount: "Frais d'entrée (employés)",
    total_net_amount: 'Montant net total',
    isin: 'ISIN',
    instrument_id: 'ID Instrument',
    gross_amount: 'Montant brut',
    net_amount: 'Montant net',
    entry_fee_employee_amount: "Frais d'entrée (employés)",
    created_at: 'Créé le',
    updated_at: 'Mis à jour le',
    firstname: 'Prénom',
    lastname: 'Nom',
    registration_number: 'Matricule',
    availability_date: 'Date de disponibilité',
    identifier: 'Identifiant',
    nav_date: 'Date de valeur',
    nav: 'Valeur liquidative',
    tax_residence_code: 'Code résidence fiscale',
    instrument_name: 'Support de placement ou paiement',
    user_currency_amount_input: 'Montant net investi',
    filled_quantity: 'Nombre de parts',
    entry_fee_company_amount: "Frais d'entrée (entreprise)",
    tax_amount: 'Montant des contributions sociales',
    linked_order_id: 'ID Ordre lié',
    individual_operation_id: "Numéro de l'opération individuelle",
    operation_type: "Type d'opération",
    mc_entry_fee_company_amount: "Frais d'entrée de l'abondement (entreprise)",
    mc_entry_fee_employee_amount: "Frais d'entrée de l'abondement (employé)",
    mc_gross_amount: 'Abondement brut',
    mc_net_amount: 'Abondement net',
    mc_tax_info: "Informations fiscales de l'abondement",
    mc_filled_quantity: "Nombre de parts de l'abondement",
    mc_user_currency_amount_input: "Montant net investi de l'abondement",
    mc_individual_operation_id: "N° opération individuelle de l'abondement",
    plan_type: 'Type de plan',
    b2b_company_plan_id: 'ID du plan',
    b2b_employee_id: "ID de l'employé",
    b2b_company_id: "ID de l'entreprise",
    b2b_contract_id: 'ID du contrat',
    user_id: "ID de l'utilisateur",
    initiator: 'Initiateur',
    bo_user_email: 'Utilisateur back-office',
    b2b_recurring_investment_id: "ID de l'investissement récurrent",
    is_recurring_investment: 'Investissement récurrent',
    b2b_correction_id: "ID de la correction d'annulation",
    b2b_correction_status: "Statut de la correction d'annulation",
    has_matching_contribution: 'A un abondement',
    from_created_at: 'Créé à partir du',
    to_created_at: "Créé jusqu'au",
  } satisfies Record<
    | keyof GetB2bIndividualOperationOneResponse
    | keyof GetB2bIndividualOperationOrderResponse
    | 'is_recurring_investment'
    | 'from_created_at'
    | 'to_created_at',
    string
  >,
  initiator: {
    backoffice: 'Back-office',
    user: 'Utilisateur',
  } satisfies Record<(typeof B2bIndividualOperationInitiatorValues)[number], string>,
  type: {
    employee_voluntary_deposit: 'Versement volontaire',
    company_voluntary_deposit: 'Versement volontaire entreprise',
    arbitrage: 'Arbitrage',
    collective_arbitrage: 'Arbitrage collectif',
    rebalancing: 'Rééquilibrage',
    withdrawal: 'Retrait',
    transfer_in: 'Transfert entrant',
    transfer_out: 'Transfert sortant',
    participation: 'Participation',
    profit_sharing: 'Intéressement',
    value_sharing_bonus: 'Prime de partage de la valeur',
    unused_vacation_days: 'Compte épargne-temps',
    voluntary_deposit_campaign: 'Campagne de versement volontaire',
    matching_contribution: 'Abondement',
    corporate_action: 'Action corporative',
    ccb_matured_election: 'Échéance légale',
    withdrawal_at_maturity: 'Rachat à échéance',
    capital_increase: 'Augmentation de capital',
  } satisfies Record<(typeof B2bIndividualOperationTypeValues)[number], string>,
};
